import BaseService from './base'

export default class lastDayPerfomanceService extends BaseService {
  static resource() {
    return 'api/v1/external/lastDayPerfomance'
  }
}
